<template>
  <div class="min-h-screen flex flex-col sm:justify-center items-center pt-6 sm:pt-0 bg-gray-100">
    <div class="max-w-6xl mx-auto py-10 sm:px-6 lg:px-8">
      <div class="shadow-lg bg-white rounded-lg rounded-b-none p-6">
        <div
          class="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div
            class="max-w-md w-full space-y-8">
            <div>
              <img
                class="mx-auto h-12 w-auto"
                src="/img/andVet_logo.png">
              <h2
                class="mt-6 text-center text-3xl font-extrabold text-gray-900">
                愛玩動物看護師 国家試験<br />オンライン模試<br />登録画面{{ isSchool ? '(学校様向け)' : '' }}
              </h2>
            </div>

            <div
              v-if="!isRegisterEnd"
              class="rounded-md shadow-sm -space-y-px">
              <div v-if="isSchool">
                <label
                  for="name"
                  class="sr-only">学校名</label>
                <input
                  id="name"
                  v-model="name"
                  name="name"
                  type="name"
                  required
                  class="appearance-none border-solid relative block w-full mt-2 px-3 py-2 border border-black placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="学校名">
              </div>
              <div
                v-if="errorsObj.name.length > 0">
                <p
                  v-for="(error, index) in errorsObj.name"
                  :key="index"
                  class="pt-1 text-sm text-red-500 tracking-widest">
                  {{ error }}
                </p>
              </div>
              <div>
                <label
                  for="email-address"
                  class="sr-only">メールアドレス</label>
                <input
                  id="email-address"
                  v-model="email"
                  name="email"
                  type="email"
                  autocomplete="email"
                  required
                  class="appearance-none border-solid relative block w-full mt-2 px-3 py-2 border border-black placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="メールアドレス">
              </div>
              <div
                v-if="errorsObj.email.length > 0">
                <p
                  v-for="(error, index) in errorsObj.email"
                  :key="index"
                  class="pt-1 text-sm text-red-500 tracking-widest">
                  {{ error }}
                </p>
              </div>
              <div>
                <label
                  for="password"
                  class="sr-only">パスワード</label>
                <input
                  id="password"
                  v-model="password"
                  name="password"
                  type="password"
                  autocomplete="current-password"
                  required
                  class="appearance-none border-solid relative block w-full mt-4 px-3 py-2 border border-black placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="パスワード(6文字以上)">
              </div>
              <div
                v-if="!errorsObj.password.length == 0">
                <p
                  v-for="error in errorsObj.password"
                  :key="error.index"
                  class="pt-1 text-sm text-red-500 tracking-widest">
                  {{ error }}
                </p>
              </div>

              <div>
                <label
                  for="confirmationPassword"
                  class="sr-only">確認用パスワード</label>
                <input
                  id="confirmationPassword"
                  v-model="confirmationPassword"
                  name="confirmationPassword"
                  type="password"
                  autocomplete="current-password"
                  required
                  class="appearance-none border-solid block w-full mt-2 px-3 py-2 border border-black placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                  placeholder="確認用パスワード">
              </div>
              <div
                v-if="!errorsObj.confirmationPassword.length <= 0">
                <p
                  v-for="error in errorsObj.confirmationPassword"
                  :key="error.index"
                  class="pt-1 text-sm text-red-500 tracking-widest">
                  {{ error }}
                </p>
              </div>
              <div>
                <button
                  :disabled="isProcessing"
                  class="disabled:opacity-60 disabled:cursor-not-allowed mt-6 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  @click="registerCustomer">
                  <span
                    class="absolute left-0 inset-y-0 flex items-center pl-3">
                    <!-- Heroicon name: solid/lock-closed -->
                    <svg
                      class="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true">
                      <path
                        fill-rule="evenodd"
                        d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                        clip-rule="evenodd" />
                    </svg>
                  </span>
                  登録実行
                </button>
              </div>
            </div>
            <div
              v-if="isRegisterEnd"
              class="mt-16">
              <p class="text-CLIENT_BL text-2xl text-center">確認用メールを送信しました。</p>
              <p class="text-CLIENT_BL text-md mt-1 text-center">メール内のリンクにアクセスして、確認をしてください。</p>
              <p class="text-CLIENT_BL text-2xl mt-2 text-center">5秒後に自動的にログインします。お待ちください。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from 'vue'
import Swal from 'sweetalert2'
import { Inertia } from '@inertiajs/inertia'
import {
  getAuth,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signInWithEmailAndPassword,
} from 'firebase/auth'
import firebaseApp from '@/Constants/configFirebase'
import REGISTER_ERROR_MESSAGES from '@/Constants/registerErrors'
import { EmailRegex } from '@/Constants/regularExpression'

const props = defineProps({
  isSchool: {
    type: Boolean,
    default: false,
  },
})

const auth = getAuth(firebaseApp)
const name = ref('')
const email = ref('')
const password = ref('')
const confirmationPassword = ref('')
const isRegisterEnd = ref(false)
const isProcessing = ref(false)

const actionCodeSettings = {
  // 環境変数の値を読み込む
  url: props.isSchool ? route('school.registrationMail.send') : route('clients.login.index'),
}

const errorsObj = reactive({
  isExistsErrors: false,
  name: [],
  email: [],
  password: [],
  confirmationPassword: [],
})

// エラーオブジェクトを初期化
const initErrors = () => {
  Object.keys(errorsObj).forEach((key) => {
    if (key === 'isExistsErrors') {
      errorsObj[key] = false
      return
    }

    errorsObj[key] = []
  })
}

const checkedErrors = () => {
  // エラーオブジェクトを初期化
  initErrors()

  // エラーをチェック（入力項目をチェック）
  if (props.isSchool && !name.value) {
    errorsObj.name.push(REGISTER_ERROR_MESSAGES.emptyName)
    errorsObj.isExistsErrors = true
  }
  if (!email.value) {
    errorsObj.email.push(REGISTER_ERROR_MESSAGES.emptyEmail)
    errorsObj.isExistsErrors = true
  }
  if (password.value !== confirmationPassword.value) {
    errorsObj.confirmationPassword.push(REGISTER_ERROR_MESSAGES.confirmationPassword)
    errorsObj.isExistsErrors = true
  }
  if (password.value.length < 6) {
    errorsObj.password.push(REGISTER_ERROR_MESSAGES.password)
    errorsObj.isExistsErrors = true
  }
  if (!email.value.match(EmailRegex)) {
    errorsObj.email.push(REGISTER_ERROR_MESSAGES.invalidEmail)
    errorsObj.isExistsErrors = true
  }
}

// 入力値をfirebaseに登録
const registerCustomer = () => {
  checkedErrors()

  if (!errorsObj.isExistsErrors) {
    isProcessing.value = true
    // 新規登録
    createUserWithEmailAndPassword(auth, email.value, password.value)
      .then(async () => {
        // 確認用メール送信
        await sendEmailVerification(auth.currentUser, actionCodeSettings)
          .then(async () => {
            await signInWithEmailAndPassword(auth, email.value, password.value)
            const userToken = await auth.currentUser.getIdToken(true)
            const userEmail = await auth.currentUser.email

            isRegisterEnd.value = true
            isProcessing.value = false

            setTimeout(() => {
              // Laravel側の認証
              Inertia.visit('/login', {
                method: 'post',
                data: {
                  name: name.value ?? '',
                  email: userEmail,
                  password: password.value,
                  idToken: userToken,
                  isSchool: props.isSchool,
                  isExam: true,
                },
              })
            }, 5000)
          })
          .catch((e) => {
            isProcessing.value = false
            Swal.fire({
              text: e,
              icon: 'error',
              confirmButtonText: '閉じる',
            })
          })
        // 確認用メール送信
      }).catch(error => {
        isProcessing.value = false
        if (error.code === 'auth/email-already-in-use') {
          Swal.fire({
            text: '既に登録済みのメールアドレスです。',
            icon: 'warning',
            confirmButtonText: '閉じる',
          })
        } else {
          Swal.fire({
            text: error.code,
            icon: 'error',
            confirmButtonText: '閉じる',
          })
        }
      })
  }
}

</script>

<style>
input {
  border: none;
}
</style>
